import React from 'react';
import { Typography } from 'antd';
import dayjs from 'dayjs';
import EventPayload from './EventPayload';
import useQueryParams from 'hooks/useQueryParams';
import TimeLineItem from './TimeLineItem';
import Ninja from '@ninja';
import EventTypeIcons from 'components/icons/EventTypeIcons';

const { Text } = Typography;

const EventTimelineItem = ({ session, url, event, trigger = 'hover' }) => {
  const { setUrlParams, searchParams, removeParams } = useQueryParams();
  const { event_details_id } = searchParams;
  const active = event_details_id == event?.id && event_details_id !== undefined;

  const handleJourneyDetails = () => {
    setUrlParams({ event_details_id: event?.id });
    removeParams(['session_details_id']);
  };

  return {
    label: (
      <div>
        <Text className='text-xs font-medium text-info'>
          {dayjs(event?.timestamp).format('MMM D, YYYY h:mm A')}
        </Text>
      </div>
    ),
    children: (
      <TimeLineItem
        title={<EventTypeIcons event={event?.type} showIcon={false} showEventName={true} />}
        data={{ ...event }}
        url={url}
        active={active}
        onClick={trigger !== 'hover' && handleJourneyDetails}
        trigger={trigger}
        type='event'
      >
        <div className='w-full max-w-[90vw] sm:w-[450px] origin-top-left '>
          {event?.payload && <EventPayload />}
          {/* {event?.type !== 'pageview' && (
            <div className='flex flex-wrap items-center p-1 mt-2 bg-white rounded-md gap-y-1'>
              <SendEventConversionButton event_id={event?.id} type='primary' />
            </div>
          )} */}
        </div>
      </TimeLineItem>
    ),
    dot: <EventTypeIcons event={event?.type} size={0.8} color={Ninja.colors.mediumBlue} />,
  };
};

export default EventTimelineItem;
